import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TabDetectionService implements OnDestroy {
  private channel: BroadcastChannel;
  private tabCount = new BehaviorSubject<number>(1);
  public tabCount$ = this.tabCount.asObservable();
  private isDisabled = false;

  constructor() {
    // Disable service if URL contains 'app-preview'
    if (window.location.href.includes('app-preview')) {
      this.isDisabled = true;
      return;
    }

    this.channel = new BroadcastChannel('tab-detection');
    this.setupTabDetection();
  }

  private setupTabDetection() {
    // Announce this tab's presence
    this.channel.postMessage({ type: 'TAB_OPENED' });

    // Listen for other tabs
    this.channel.onmessage = (event) => {
      if (event.data.type === 'TAB_OPENED') {
        const tabCount = this.tabCount.value + 1;
        this.tabCount.next(tabCount);
        // Respond to let the new tab know we exist
        this.channel.postMessage({ type: 'TAB_EXISTS' });
        if (tabCount > 1) {
          alert(`Warning: Multiple tabs detected! Please use only one tab.`);
        }
      } else if (event.data.type === 'TAB_EXISTS') {
        const tabCount = this.tabCount.value + 1;
        this.tabCount.next(tabCount);
        if (tabCount > 1) {
          alert(`Warning: Multiple tabs detected! Please use only one tab.`);
        }
      } else if (event.data.type === 'TAB_CLOSED') {
        this.tabCount.next(Math.max(1, this.tabCount.value - 1));
      }
    };

    // Handle tab closing
    window.addEventListener('beforeunload', () => {
      this.channel.postMessage({ type: 'TAB_CLOSED' });
    });
  }

  ngOnDestroy() {
    if (this.isDisabled) return;

    this.channel.postMessage({ type: 'TAB_CLOSED' });
    this.channel.close();
  }
}
